import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BalooSyncLogComponent } from '@fi-app/external-platform-integration/baloo/baloo-sync-log/baloo-sync-log.component';
import { BalooSyncLogDetailsComponent } from '@fi-app/external-platform-integration/baloo/baloo-sync-log/baloo-sync-log-details/baloo-sync-log-details.component';
import { BalooSyncLogDetailsDialogComponent } from '@fi-app/external-platform-integration/baloo/baloo-sync-log/baloo-sync-log-details-dialog/baloo-sync-log-details-dialog.component';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { BalooSyncLogListComponent } from './baloo-sync-log-list/baloo-sync-log-list.component';
import { FiPrintDownloadModule } from '@fi-shared/fi-print-download/fi-print-download.module';
import { MatButtonModule } from '@angular/material/button';
import { FiAutocompleteItemsModule } from '@fi-shared/fi-autocomplete-items/fi-autocomplete-items.module';
import { FiRollupContentModule } from '@fi-shared/rollup/rollup-content.module';
import { MatIconModule } from '@angular/material/icon';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { FiMatTabGroupBookmarkLayoutModule } from '@fi-shared/fi-mat-card-bookmark-layout/fi-mat-tab-group-bookmark-layout.module';
import { FiEmptyListModule } from '@fi-shared/fi-empty-list/fi-empty-list.module';

@NgModule({
    imports: [
        CommonModule,
        FiWhenScrolledModule,
        FiWrapperTableModule,
        FiAppTextSharedModule,
        MatCardModule,
        MatTabsModule,
        FiPrintDownloadModule,
        MatButtonModule,
        FiAutocompleteItemsModule,
        FiRollupContentModule,
        MatIconModule,
        FiFormatDateModule,
        FiMatTabGroupBookmarkLayoutModule,
        FiEmptyListModule,
    ],
    declarations: [
        BalooSyncLogComponent,
        BalooSyncLogDetailsComponent,
        BalooSyncLogDetailsDialogComponent,
        BalooSyncLogListComponent,
    ],
    exports: [BalooSyncLogDetailsComponent],
})
export class BalooSyncLogModule {}
